{
  "nl": {
    "login": {
      "acceptTosPrefix": "Ik ga akkoord met de ",
      "acceptTos": "algemene voorwaarden",
      "acceptTosRequired": "U moet akkoord gaan met de algemene voorwaarden om een account aan te maken.",
      "auth/invalid-credential": "Het wachtwoord is ongeldig voor het opgegeven e-mailadres, of er bestaat geen account voor dit e-mailadres.",
      "auth/too-many-requests": "Te veel verzoeken, probeer het later opnieuw.",
      "auth/invalid-action-code": "Om veiligheidsredenen verlopen wachtwoord reset links na een tijdje. Als u nog steeds uw wachtwoord wilt resetten, kunt u een nieuwe reset e-mail aanvragen.",
      "auth-ziggu/invalid-invitation-code": "Controleer bij de persoon die het met u heeft gedeeld of er een nieuwe link beschikbaar is. Als u al een account heeft, meld je dan aan.",
      "auth-ziggu/user-created": "Uw gebruikersaccount is aangemaakt! 🎉 We melden je nu aan, even geduld..",
      "title_login": "Welkom terug!",
      "title_password_forgot": "Wachtwoord vergeten?",
      "title_password_reset": "Reset uw wachtwoord",
      "title_expired_reset": "Oeps, dit is een verlopen link..",
      "title_expired_signup": "Deze uitnodigingslink is niet meer actief",
      "title_signup": "Voltooi uw registratie",
      "backToLogin": "Terug naar aanmelden",
      "cookiePolicy": "Cookiebeleid",
      "privacyPolicy": "Privacybeleid",
      "googleLogin": "Aanmelden met Google",
      "emailAddress": "E-mailadres",
      "emailAddressRequired": "E-mailadres is verplicht",
      "notification_error_session_expired": "Uw sessie is verlopen, meld je opnieuw aan.",
      "notification_error_no_access": "Uw account heeft geen toegang.",
      "notification_success_logout": "U bent afgemeld van uw account.",
      "password": "Wachtwoord",
      "password_confirm": "Wachtwoord bevestiging",
      "passwordForgot": "Wachtwoord vergeten?",
      "passwordRequired": "Wachtwoord is verplicht",
      "passwordLengthRequired": "Wachtwoord moet minimaal 8 tekens bevatten",
      "passwordConfirmRequired": "Wachtwoord bevestiging is verplicht",
      "passwordConfirmMatchRequired": "Wachtwoord bevestiging komt niet overeen",
      "success_password_forgot": "Als u een actief account heeft, is er een wachtwoord reset e-mail verzonden naar {email}. Controleer uw e-mail inbox, de link om uw wachtwoord opnieuw in te stellen verloopt over 1 uur.",
      "success_password_reset": "Wachtwoord reset succesvol, u wordt nu aangemeld...",
      "submit_login": "Aanmelden",
      "submit_password_forgot": "Wachtwoord reset aanvragen",
      "submit_password_reset": "Wachtwoord resetten",
      "submit_expired_reset": "Nieuwe wachtwoord reset aanvragen",
      "submit_expired_signup": "Terug naar aanmelden",
      "submit_signup": "Account aanmaken",
      "termsandconditionsPolicy": "Algemene voorwaarden"
    }
  }
}
